class horarios {
	constructor(timetable) {
		this.horarioDomicilio = this.generarHorario(timetable, "domicilio");
		this.horarioApertura = this.generarHorario(timetable, "apertura");
		this.horarioRecogida = this.generarHorario(timetable, "recoger");
		this.date = new Date();
		this.hour = this.date.getHours() == 0 ? 24 : this.date.getHours();
		this.minutes = this.date.getMinutes();
		this.day = this.date.getDay();
	}

	get devolverArray() {
		return this.timetable;
	}

	generarHorario(timetable, tipo) {
		let horario = timetable.semana.map(function (x) {
			return x[tipo];
		});

		let tabla = horario.map(function (x) {
			let i = timetable.tipos.findIndex(e => x == e.nombre);
			if (i >= 0) {
				return timetable.tipos[i].rangos;
			} else {
				return [];
			}

		});

		return tabla;
	}

	abiertoHoy(tipo) {
		let abierto;
		switch (tipo) {
			case "domicilio":
				abierto = this.evaluarHorario(this.horarioDomicilio, this.hour, this.minutes, this.day);
				break;
			case "recoger":
				abierto = this.evaluarHorario(this.horarioRecogida, this.hour, this.minutes, this.day);
				break;
			case "apertura":
				abierto = this.evaluarHorario(this.horarioApertura, this.hour, this.minutes, this.day);
				break;
			default:
				abierto = "caso no controlado";
				break;
		}

		return abierto;
	}

	evaluarHorario(data, horaAhora, minAhora, day) {
		let opened = false;
		let marcadorHoraSiguiente = 0;
		let marcadorMinutosSiguiente = 0;
		let marcadorHoraCierre = 0;
		let marcadorMinutosCierre = 0;
		let horarioEvaluar;
		let diaArray = day - 1
		console.log(diaArray);
		if (diaArray == -1) { diaArray = 6 }
		if (data[diaArray].length > 0) {
			data[diaArray].forEach(function (e1) {
				let horaInicio = parseInt((e1.inicio.split(":"))[0]);
				let minutoInicio = parseInt((e1.inicio.split(":"))[1]);
				let horaFin = parseInt((e1.fin.split(":"))[0]);
				let minutoFin = parseInt((e1.fin.split(":"))[1]);

				//*********************************************** ABIERTO / CERRADO ***********************************************
				// Condiciones a evaluar
				var cond1 = horaInicio <= horaAhora;
				var cond2 = minutoInicio < minAhora;
				var cond3 = horaFin >= horaAhora;
				var cond4 = minutoFin > minAhora;

				if (horaFin > horaInicio) {
					if (cond1 && cond3) {
						if (horaFin == horaAhora) {
							cond4 ? opened = true : null;                          //Si es la hora de cierre evalua los minutos
						} else if (horaInicio == horaAhora) {
							cond2 ? opened = true : null;                          //Si es la hora de apertura evalua los minutos
						} else {
							opened = true;
						}
					}
				} else {
					if (cond1 || cond3) {
						if (horaFin == horaAhora) {
							cond4 ? opened = true : null;                          //Si es la hora de cierre evalua los minutos
						} else if (horaInicio == horaAhora) {
							cond2 ? opened = true : null;                          //Si es la hora de apertura evalua los minutos
						} else {
							opened = true;
						}
					}
				}



				//********************************* SIGUIENTES APERTURA / CIERRE *********************************
				var cond5 = marcadorHoraSiguiente == 0 && horaInicio >= horaAhora                        //Evalua si la siguiente hora es la siguiente mayor, para establecer la apertura siguiente
				if (cond5) {
					if (horaInicio == horaAhora) {
						if (minutoInicio > minAhora) {
							marcadorHoraSiguiente = horaInicio
							marcadorMinutosSiguiente = minutoInicio
						}
					} else {
						marcadorHoraSiguiente = horaInicio
						marcadorMinutosSiguiente = minutoInicio
					}
				}

				var cond6 = marcadorHoraCierre == 0 && horaFin >= horaAhora                        //Evalua si la siguiente hora es la siguiente mayor, para establecer el cierre siguiente
				if (cond6) {
					if (horaFin == horaAhora) {
						if (minutoFin > minAhora) {
							marcadorHoraCierre = horaFin
							marcadorMinutosCierre = minutoFin
						}
					} else {
						marcadorHoraCierre = horaFin
						marcadorMinutosCierre = minutoFin
					}
				}

				marcadorHoraSiguiente == 24 ? marcadorHoraSiguiente = "00" : null;
				marcadorMinutosSiguiente == 0 ? marcadorMinutosSiguiente = "00" : null;
				marcadorHoraCierre == 24 ? marcadorHoraCierre = "00" : null;
				marcadorMinutosCierre == 0 ? marcadorMinutosCierre = "00" : null;

				// console.log("siguiente apertura", marcadorHoraSiguiente, marcadorMinutosSiguiente, "hora cierre", marcadorHoraCierre, marcadorMinutosCierre)


			})

		}

		return opened;
	}





	// /*Evalua el horario construyendo uno en un objeto*/
	// timetableInMinutes(horario, hh, mm, day){
	//     var horarioJSON = timetableComplete(buildUpJSONTImetable(), this.timetable[this.day]);
	//     //var cambiosApertura = nextOpening(horarioJSON, hh, mm, isOpen);

	//     //textoEnHorarios(isOpen, cambiosApertura, clase);
	//     return horarioJSON;
	//     /*Contruye horario desde cero*/
	//     function buildUpJSONTImetable(){
	//         var myjson = {};
	//         for(var i=1; i<=27; i++){
	//             myjson[i] = [];
	//             for(var j=0; j<=59; j++){
	//                 myjson[i][j] = "cerrado"
	//             }
	//         }
	//         return myjson;
	//     }
	//     /*Evalua completa el horario por el atribuo cerrado/abierto*/
	//     function timetableComplete(horarioJSON, horario){
	//         horario.forEach(function(e1, i1){
	//             var hh1 = cambio00a24( parseInt(( e1[0]).split(":")[0] ) );
	//             var mm1 = parseInt(( e1[0]).split(":")[1] );
	//             var hh2 = cambio00a24( parseInt(( e1[1]).split(":")[0] ) );
	//             var mm2 = parseInt(( e1[1]).split(":")[1] );

	//             //Casos especiales: primera hora, ultima hora, hora 00

	//             for(var i=hh1; i<= hh2; i++){
	//                 if(i == hh1){
	//                     for(var j=mm1; j<= 59; j++){
	//                         horarioJSON[i][j] = "abierto"
	//                     }
	//                 }else if(i == hh2){
	//                     for(var j=0; j<= mm2; j++){
	//                         horarioJSON[i][j] = "abierto"
	//                     }
	//                 }else{
	//                     for(var j=0; j<= 59; j++){
	//                         horarioJSON[i][j] = "abierto"
	//                     }
	//                 }
	//             }
	//         })
	//         return horarioJSON;
	//     }
	//     function cambio00a24(data){
	//         if(data == 0){
	//             data = 24
	//         }
	//         return data;
	//     }
	// }


	// nextOpening(){
	//     let horarioJSON = this.timetableInMinutes();
	//     var tempOpen    = horarioJSON[this.hour][this.minutes];
	//     var cambiosApertura = [];

	//     for(var i=this.hour; i<= Object.entries(horarioJSON).length; i++){
	//         for(var j=0; j<= 59; j++){
	//             if(horarioJSON[i][j] != tempOpen){
	//                 var horaTemp    = timeFormat(i);
	//                 var minTemp     = timeFormat(j);
	//                 cambiosApertura.push(horaTemp+":"+minTemp)
	//                 tempOpen        = horarioJSON[i][j];
	//             }
	//         }
	//     }

	//     return cambiosApertura;

	//     function timeFormat(hh){
	//         return String(hh).length < 2 ? String(hh)+"0" : String(hh);
	//     }
	// }
}

export { horarios }